import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const WhyChooseMowebPython = () => {
    return (
        <div className="section-py">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Choose Us as Your Trusted Python Development Company?
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-10">
                    <div>
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/python/svg/ic-proven-industry.svg" width={36} height={36} alt="build-for-complex" />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Proven Industry Expertise</p>
                        <p className="fs-md mb-0">
                            Leverage our years of experience delivering cutting-edge, custom Python development services across
                            diverse industries.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/python/svg/ic-end-to-end.svg" width={36} height={36} alt="proven-impact" />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">End-to-End Development</p>
                        <p className="fs-md mb-0">
                            From backend architecture to frontend interfaces and seamless API integrations, we build complete,
                            high-performance applications.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/python/svg/ic-agile.svg" width={36} height={36} alt="Speed, Without Compromise" />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Agile & Transparent Execution</p>
                        <p className="fs-md mb-0">
                            Stay informed at every stage with a collaborative, iterative approach that ensures timely delivery.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/python/svg/img-scalable.svg"
                                width={36}
                                height={36}
                                alt="Speed, Without Compromise"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Scalable, Future-Ready Solutions</p>
                        <p className="fs-md mb-0">
                            Our Python applications are built for performance, security, and long-term growth.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/python/svg/ic-dedicated-support.svg"
                                width={36}
                                height={36}
                                alt="End-to-End Partnership"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Dedicated Support & Optimization</p>
                        <p className="fs-md mb-0">
                            We go beyond development, offering continuous monitoring, enhancements, and long-term technical
                            support.
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 bg-why-choose rounded-10">
                    <div className="lg:col-span-12 p-12">
                        <h2 className="mb-3 text-white">Let&apos;s Build Something Exceptional Together</h2>
                        <p className="mb-3 text-white">
                            Partner with a top Python development company to create high-impact solutions that fuel growth and
                            innovation.
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Schedule a call with us'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyChooseMowebPython;
